var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprovedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.82,112.59c-33.15-34-78.92-56.69-125.08-67.23q-10-2.3-20.14-4C177.22,24.07,114.63,115,96.47,154.28S30.58,278.63,31.27,329.13s107.22,139,217.2,141.8S444.93,413.52,463.6,319.44c7.88-39.66,16-81.67,7.53-121.94C464.13,164.15,447.4,135.75,424.82,112.59Z",
    style: {
      fill: "#55FF6A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.82,112.59c-33.15-34-78.92-56.69-125.08-67.23q-10-2.3-20.14-4C177.22,24.07,114.63,115,96.47,154.28S30.58,278.63,31.27,329.13s107.22,139,217.2,141.8S444.93,413.52,463.6,319.44c7.88-39.66,16-81.67,7.53-121.94C464.13,164.15,447.4,135.75,424.82,112.59Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 29.88,
    y1: 436.56,
    x2: 483.67,
    y2: 436.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.53,317c5.63.18,17.24-4.75,17.25-4.75s-5.58-6.67-6-7c-4.71-4.35-16.38-10-22.64-6.47-4.51,2.55-5.26,8.37-2.4,12.43S58.74,316.8,63.53,317Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.09,349.28c5.26-1.25,14.51-8.45,15.24-9a151.39,151.39,0,0,0,13.33,15c2.77,2.76,5.64,5.45,8.55,8.11-1.51-1-2.87-1.91-3.07-2-5.7-2.95-18.44-5.32-23.54-.26-3.68,3.64-2.87,9.46,1,12.62s10.17,3.1,14.83,2,12.73-7.11,14.83-8.72l3.38,3c5.43,4.82,10.86,9.61,16.05,14.47,1.83,1.72,3.57,3.47,5.32,5.22-1.34-.9-2.48-1.65-2.67-1.75-5.69-3-18.43-5.32-23.54-.26-3.68,3.64-2.86,9.46,1,12.62s10.16,3.1,14.82,2,12-6.53,14.46-8.43c1.74,1.84,3.48,3.69,5.07,5.55,1.07,1.3,2.18,2.48,3.17,3.84l3,3.95c1.82,2.58,3.72,5.23,5.43,7.79,1.2,1.77,2.32,3.49,3.44,5.21-1.8-1.73-5.39-5-5.73-5.28-5.18-3.78-17.41-8-23.23-3.82-4.18,3-4.26,8.92-.95,12.62s9.57,4.61,14.35,4.21c5.26-.43,15.11-5.87,16.34-6.56,1.86,2.85,3.64,5.64,5.27,8.31,1.48,2.38,2.84,4.65,4.13,6.83l4.18-1.66c-1.46-2.37-3-4.84-4.71-7.45-1.87-2.9-3.93-6-6.08-9.1a91.1,91.1,0,0,0,7.42-7.93c4.89,2.34,15.37,3.19,16.72,3.29,0,3.4-.08,6.71-.18,9.84-.07,2.15-.15,4.21-.24,6.2l4.43-1.76c0-1.42.05-2.86.06-4.36,0-3.45,0-7.15,0-10.94,1.36-.24,12.47-2.24,16.83-5.23,3.95-2.71,8.23-7.26,8.47-12.33s-3.54-9.47-8.71-9.18c-7.18.39-14,11.42-15.6,17.63-.1.37-.7,4.46-1,7,0-1.55,0-3.05-.11-4.65-.08-3.15-.26-6.3-.44-9.68-.15-1.64-.29-3.28-.44-4.95s-.44-3.39-.65-5.1c-.58-4-1.36-7.93-2.23-11.93,2.76-.08,12.57-.51,16.9-2.6s9.24-5.93,10.24-10.91-2.06-9.89-7.22-10.39c-7.15-.7-15.54,9.18-18.09,15.07-.16.36-1.51,4.79-2.21,7.24-.54-2.4-1.07-4.79-1.7-7.2-1.82-6.94-3.87-13.92-5.89-20.88-.62-2.14-1.21-4.27-1.81-6.4,1,0,12.65-.29,17.51-2.63,4.32-2.08,9.24-5.93,10.24-10.9s-2.06-9.89-7.22-10.39c-7.15-.7-15.54,9.17-18.09,15.06-.19.44-2.13,6.82-2.55,8.47-1.32-4.7-2.59-9.4-3.65-14.08a149.15,149.15,0,0,1-3.17-19.16c.45,0,12.63-.22,17.61-2.62,4.31-2.08,9.24-5.93,10.23-10.91s-2.06-9.89-7.21-10.39c-7.15-.7-15.54,9.18-18.09,15.06-.2.47-2.29,7.33-2.58,8.6,0-.37-.11-.76-.14-1.13a110,110,0,0,1,.34-19.46c.34-3.58.86-7,1.44-10.27,2.27.19,12.67.95,17.38-.71,4.52-1.6,9.84-4.88,11.37-9.72s-1-10.06-6-11.12c-7-1.48-16.45,7.41-19.63,13-.18.3-1.59,3.57-2.59,6,.28-1.48.55-3,.85-4.43,1.12-5.32,2.47-10.12,3.7-14.36.72-2.41,1.42-4.57,2.09-6.58,2.33-1,11.66-5,15-8.61s6.48-8.86,5.62-13.86-5.5-8.48-10.48-7.1c-6.92,1.93-11.19,14.17-11.44,20.58,0,.55.62,9.26.74,9.21l.15-.06c-.69,1.93-1.41,4-2.14,6.28-1.33,4.23-2.79,9-4,14.32a150.69,150.69,0,0,0-3.18,17.34,111.46,111.46,0,0,0-.77,19.7c0,.07,0,.15,0,.23-.74-2-3-7.4-3.23-7.8-3.12-5.61-12.44-14.61-19.49-13.21-5.08,1-7.61,6.31-6.15,11.06s6.76,8.2,11.26,9.84c5.08,1.85,16.76.95,17.69.88a151.46,151.46,0,0,0,2.83,19.88c.79,3.83,1.7,7.66,2.66,11.48-.7-1.68-1.34-3.18-1.45-3.38-3.12-5.61-12.44-14.6-19.49-13.2-5.08,1-7.61,6.31-6.15,11s6.76,8.2,11.26,9.84,14.55,1.1,17.18.92c.39,1.46.75,2.93,1.14,4.39,1.87,7,3.76,14,5.41,20.93.58,2.44,1.07,4.86,1.56,7.28-.62-1.49-1.16-2.74-1.26-2.92-3.12-5.61-12.45-14.61-19.49-13.21-5.08,1-7.61,6.31-6.16,11.06s6.77,8.19,11.27,9.84,13.57,1.15,16.71.94c.43,2.5.86,5,1.16,7.44.17,1.66.45,3.26.53,4.94s.22,3.32.33,5c.1,3.15.21,6.41.23,9.49,0,2.14,0,4.18,0,6.24-.55-2.43-1.73-7.17-1.87-7.56a33,33,0,0,0-10.05-13.28,11.12,11.12,0,0,0-.81-1.71c-2.54-4.26-8.17-5.94-12.33-2.85-5.76,4.28-5.35,17.24-3.28,23.31.12.36,1.88,4.1,3,6.44-.88-1.27-1.72-2.52-2.65-3.82-1.81-2.58-3.7-5.11-5.71-7.83l-3.1-3.88c-1-1.32-2.23-2.59-3.35-3.9-2.67-3-5.51-5.87-8.44-8.71,2.26-1.6,10.19-7.37,12.66-11.5s4.43-10.05,2.52-14.75-7.18-7.11-11.75-4.69c-6.35,3.37-7.9,16.23-6.78,22.55.07.39,1.38,4.84,2.15,7.26-1.77-1.69-3.54-3.4-5.39-5.06-5.34-4.79-10.9-9.48-16.43-14.17-1.69-1.44-3.36-2.9-5-4.34.81-.56,10.4-7.22,13.16-11.85,2.45-4.12,4.43-10,2.52-14.74s-7.18-7.12-11.75-4.69c-6.35,3.36-7.9,16.23-6.78,22.54.08.48,2,6.87,2.55,8.47-3.7-3.19-7.35-6.4-10.82-9.72a149.9,149.9,0,0,1-13.21-14.23c.38-.26,10.41-7.16,13.24-11.91,2.45-4.11,4.43-10,2.52-14.74s-7.18-7.11-11.75-4.69c-6.35,3.36-7.9,16.23-6.78,22.55.09.49,2.13,7.37,2.59,8.59-.23-.3-.51-.57-.74-.87a109.28,109.28,0,0,1-10.45-16.42c-1.69-3.17-3.13-6.29-4.47-9.36,2-1.09,11.09-6.19,14.11-10.18,2.89-3.82,5.51-9.49,4.13-14.37s-6.36-7.86-11.17-6c-6.68,2.65-9.63,15.27-9.21,21.67,0,.35.64,3.86,1.13,6.41-.58-1.39-1.2-2.82-1.73-4.17-2-5.05-3.53-9.8-4.84-14-.73-2.41-1.34-4.6-1.88-6.65,1.4-2.1,7-10.62,7.77-15.46s.52-11-3-14.66-9.26-4-12.65-.14c-4.71,5.43-1.52,18,1.8,23.48.29.47,5.64,7.37,5.71,7.26l.08-.12c.49,2,1,4.11,1.68,6.42,1.23,4.25,2.65,9.05,4.55,14.16a150,150,0,0,0,6.91,16.21,110.54,110.54,0,0,0,10.22,16.86c0,.06.11.12.15.18-1.7-1.23-6.59-4.51-7-4.72-5.69-3-18.43-5.32-23.54-.26-3.68,3.64-2.86,9.45,1,12.61S76.43,350.4,81.09,349.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.07,272.34c.13,0-1-8.64-1.1-9.17-1.53-6.23-8.14-17.38-15.31-17.89-5.16-.36-9,4.08-8.85,9s4.35,9.69,8.26,12.47C170.66,270.05,183.06,272.34,183.07,272.34Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M465.5,282.73c-5.19,2.18-17.79,1.7-17.8,1.7s2.83-8.22,3.08-8.71c2.86-5.75,11.75-15.17,18.86-14.1,5.12.77,7.89,5.95,6.66,10.76S469.92,280.88,465.5,282.73Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M321.1,290.39c5-.12,14.44-4.53,16.5-5.52,1.71,2.87,3.41,5.87,5,9.09A109,109,0,0,1,349.83,312c.11.36.17.74.27,1.11-.72-1.09-5.11-6.76-5.46-7.12-4.48-4.6-15.83-10.85-22.27-7.65-4.63,2.3-5.69,8.08-3,12.28s8.67,6.14,13.44,6.55c5.5.47,17-3.65,17.39-3.81a148.84,148.84,0,0,1,3.85,19c.67,4.75,1.15,9.59,1.59,14.45-1-1.39-5.06-6.66-5.39-7-4.48-4.6-15.83-10.85-22.27-7.65-4.64,2.3-5.69,8.08-3.05,12.28s8.67,6.14,13.45,6.55c5.37.46,16.37-3.44,17.29-3.77.2,2.2.41,4.41.59,6.62.59,7.23,1.15,14.48,1.93,21.62.26,2.47.62,4.89,1,7.33-1.52-2-4.36-5.7-4.64-6-4.48-4.59-15.83-10.84-22.27-7.65-4.63,2.3-5.69,8.08-3,12.29s8.67,6.14,13.44,6.55,14.12-2.67,16.73-3.58c.6,4,1.29,8,2.15,11.94.41,1.68.72,3.42,1.21,5s.9,3.2,1.35,4.78c1,3.23,2,6.23,3,9.21.52,1.51,1,2.92,1.56,4.38-1.23-2.3-3.25-5.9-3.47-6.21-3.73-5.22-14-13.12-20.85-10.94-4.93,1.58-6.85,7.13-4.87,11.68s7.64,7.39,12.3,8.52c5.13,1.24,16.23-.84,17.58-1.1,1.29,3.57,2.58,7,3.85,10.25.54,1.39,1.08,2.73,1.61,4l4.76.08c-.79-1.83-1.6-3.73-2.43-5.72-1.2-2.88-2.44-5.95-3.67-9.13,1.23-.57,10.72-5.09,14.46-9a93.85,93.85,0,0,0,9.76,4.77c-.9,3.69-1.73,7.29-2.45,10.67-.65,3-1.23,5.9-1.76,8.63l1.76,0H398c.43-2.49.9-5.08,1.42-7.81.59-3.08,1.25-6.32,2-9.65,1.39.21,12.54,1.79,17.6.33,4.61-1.33,10.1-4.31,11.92-9s-.38-10.1-5.38-11.46c-6.94-1.88-16.86,6.46-20.35,11.84-.23.34-2.42,4.71-3.49,7,.45-2,.88-4,1.38-6.09.69-3,1.51-6.15,2.3-9.21l1.4-4.76c.45-1.63,1.07-3.12,1.6-4.71.83-2.31,1.8-4.66,2.77-7,3,.89,11.91,3.34,16.51,2.74s10.63-2.72,13.14-7.13,1.16-10-3.58-12.14c-6.57-2.91-17.63,3.83-21.91,8.62-.14.15-.93,1.26-1.87,2.58,1-2.26,2-4.52,3.12-6.77,3.12-6.39,6.5-12.8,9.86-19.24.7-1.34,1.38-2.69,2.07-4,2.54.76,12.15,3.5,17,2.87s10.64-2.73,13.14-7.13,1.16-10-3.58-12.14c-6.56-2.91-17.63,3.83-21.91,8.61-.15.18-1.1,1.5-2.15,3,1.78-3.53,3.5-7.06,5.1-10.62a148.69,148.69,0,0,0,7.12-18.79c.89.28,12.1,3.72,17.46,3,4.75-.62,10.63-2.72,13.14-7.13s1.15-10-3.58-12.14c-6.57-2.91-17.64,3.83-21.91,8.62-.3.34-3.7,5.15-4.86,6.9l.07-.22A111.3,111.3,0,0,0,447,295.83a150.23,150.23,0,0,0,.69-17.61c0-5.46-.42-10.44-.79-14.85-.22-2.39-.46-4.57-.71-6.6l.12.09c.11.07,2.65-8.28,2.75-8.82,1.15-6.32-.33-19.19-6.66-22.59-4.56-2.44-9.88,0-11.78,4.63s0,10.62,2.45,14.75,10.71,10.23,12.77,11.69c.21,2.12.42,4.38.6,6.88.27,4.41.53,9.39.46,14.82,0,1.45-.09,3-.14,4.52-.45-2.56-1.11-6.07-1.22-6.4-1.88-6.13-9.13-16.88-16.31-17-5.18-.07-8.76,4.59-8.32,9.54s4.91,9.42,9,12c4.23,2.65,14.54,4.19,16.8,4.5-.15,3.34-.39,6.77-.85,10.33a109.14,109.14,0,0,1-3.93,19.07c-.11.35-.27.71-.38,1.07,0-1.3-.54-8.46-.63-8.95-1.2-6.3-7.22-17.78-14.35-18.66-5.14-.64-9.21,3.59-9.32,8.56s3.84,9.9,7.6,12.88c4.33,3.43,16.16,6.31,16.61,6.42a149.89,149.89,0,0,1-7.3,18c-2.06,4.33-4.33,8.63-6.65,12.93,0-1.7-.54-8.34-.63-8.82-1.2-6.3-7.22-17.78-14.35-18.66-5.14-.64-9.2,3.6-9.32,8.56s3.85,9.91,7.61,12.88c4.22,3.35,15.55,6.16,16.5,6.4-1.05,1.95-2.09,3.9-3.17,5.84-3.49,6.36-7,12.71-10.31,19.09-1.14,2.21-2.18,4.44-3.24,6.65-.14-2.54-.5-7.16-.57-7.55-1.2-6.3-7.22-17.78-14.35-18.66-5.14-.64-9.21,3.59-9.32,8.56s3.84,9.91,7.6,12.88,13.25,5.56,15.92,6.25c-1.72,3.7-3.35,7.41-4.79,11.15-.58,1.62-1.28,3.24-1.75,4.83l-1.51,4.72c-.92,3.27-1.78,6.3-2.56,9.36-.4,1.54-.74,3-1.12,4.51.24-2.59.55-6.71.54-7.09-.23-6.41-4.44-18.67-11.36-20.62-5-1.41-9.64,2.16-10.5,7.05a9.87,9.87,0,0,0-.15,1.88,33,33,0,0,0-4.68,16c0,.41.59,5.26.94,7.73-.74-1.92-1.48-3.82-2.21-5.84-1.09-2.88-2.13-6-3.17-8.95q-.72-2.36-1.45-4.74c-.52-1.61-.83-3.2-1.27-4.82-.58-2.38-1.06-4.87-1.55-7.36,3-.92,11.78-3.79,15.28-6.82s7.37-8.14,7-13.2-4.57-9-9.68-8.15c-7.08,1.2-12.6,12.92-13.52,19.27,0,.21-.09,1.57-.14,3.18-.4-2.43-.81-4.87-1.13-7.35-.92-7.06-1.64-14.27-2.39-21.49-.16-1.51-.33-3-.5-4.51,2.54-.77,12.06-3.79,15.74-7s7.36-8.14,7-13.2-4.58-9-9.68-8.15c-7.09,1.2-12.6,12.93-13.53,19.28,0,.22-.09,1.85-.15,3.67-.46-3.92-1-7.82-1.6-11.67a150.23,150.23,0,0,0-4.42-19.59c.89-.26,12.13-3.58,16.22-7.12,3.62-3.13,7.36-8.13,7-13.2s-4.58-9-9.68-8.14c-7.09,1.19-12.6,12.92-13.53,19.27-.06.45-.25,6.34-.24,8.44l-.06-.23a110.07,110.07,0,0,0-7.73-18.14,153.09,153.09,0,0,0-9.13-15.07c-3.05-4.52-6.11-8.47-8.86-12-1.5-1.87-2.9-3.55-4.23-5.11h.15c.13,0-2.36-8.36-2.57-8.87-2.52-5.9-10.86-15.82-18-15.16-5.16.47-8.23,5.48-7.27,10.36s5.87,8.85,10.18,10.95,14.57,2.62,17.09,2.71c1.35,1.64,2.77,3.41,4.3,5.41,2.66,3.52,5.63,7.53,8.56,12.1.79,1.22,1.58,2.56,2.37,3.84-1.78-1.88-4.27-4.44-4.54-4.66-5-4.08-16.93-9-23-5.16-4.36,2.8-4.77,8.66-1.68,12.54S316.31,290.51,321.1,290.39Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M337.91,283.54c-.11.07-2.16-8.42-2.23-9-.79-6.37,1.43-19.13,7.95-22.16,4.7-2.18,9.87.61,11.49,5.3s-.63,10.61-3.29,14.59C348.7,277,337.92,283.53,337.91,283.54Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Banknotes--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.54,
    y: 118.97,
    width: 34.63,
    height: 59.96,
    transform: "matrix(-0.67, 0.74, -0.74, -0.67, 320.72, 156.12)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.29,173.68a4.19,4.19,0,0,1,5.91-.28c.13.12.24.24.36.37l13.38-14.7-.41-.32a4.2,4.2,0,0,1-.28-5.91l.19-.18-31.69-28.83-.16.2a4.18,4.18,0,0,1-5.9.27,3.15,3.15,0,0,1-.36-.37L99.94,138.64a4.12,4.12,0,0,1,.41.32,4.18,4.18,0,0,1,.28,5.9,4.27,4.27,0,0,1-.38.36L132,174.08C132.07,173.94,132.18,173.81,132.29,173.68Zm-11.5-29.34a6.85,6.85,0,1,1,.45,9.67A6.85,6.85,0,0,1,120.79,144.34Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.34,
    y: 15.19,
    width: 34.63,
    height: 59.96,
    transform: "translate(246.76 -229.99) rotate(75.22)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.91,53.2a4.19,4.19,0,0,1,3-5.11,4.54,4.54,0,0,1,.51-.09l-5.08-19.23-.49.17a4.18,4.18,0,0,1-5.1-3,2.27,2.27,0,0,1-.06-.25L248.25,36.64c0,.08.05.16.08.25a4.18,4.18,0,0,1-3,5.1,3.06,3.06,0,0,1-.51.1l5.08,19.23a2.84,2.84,0,0,1,.49-.17,4.17,4.17,0,0,1,5.1,3,3.06,3.06,0,0,1,.1.51l41.47-10.94A4,4,0,0,1,296.91,53.2ZM266,46.92a6.85,6.85,0,1,1,8.37,4.87A6.85,6.85,0,0,1,266,46.92Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.28,
    y: 207.98,
    width: 34.63,
    height: 59.96,
    transform: "translate(403.4 681.71) rotate(-125.94)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.07,239.22a4.19,4.19,0,0,1-.93,5.84,4,4,0,0,1-.44.27l11.67,16.1c.13-.11.26-.23.4-.33a4.17,4.17,0,0,1,5.83.93,1.7,1.7,0,0,1,.15.22l34.68-25.15-.16-.2a4.18,4.18,0,0,1,.93-5.84,4,4,0,0,1,.44-.27L391,214.69a4.12,4.12,0,0,1-.4.33,4.18,4.18,0,0,1-5.84-.93,4,4,0,0,1-.27-.44l-34.72,25.17C349.85,239,350,239.08,350.07,239.22Zm31.07-5.28a6.85,6.85,0,1,1-9.57-1.53A6.84,6.84,0,0,1,381.14,233.94Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.81,
    y: 106.31,
    width: 34.63,
    height: 59.96,
    transform: "translate(44.17 365.81) rotate(-50.7)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.4,111.94a4.18,4.18,0,0,1-5.88.58,4.26,4.26,0,0,1-.38-.35l-12.59,15.39.42.3a4.19,4.19,0,0,1,.59,5.88l-.18.19,33.16,27.13c0-.07.09-.14.15-.21a4.18,4.18,0,0,1,5.88-.58l.38.35,12.59-15.39a4,4,0,0,1-.42-.3,4.18,4.18,0,0,1-.59-5.88,3.15,3.15,0,0,1,.36-.37L400.7,111.51A4.15,4.15,0,0,1,400.4,111.94Zm13,28.69a6.85,6.85,0,1,1-1-9.64A6.86,6.86,0,0,1,413.43,140.63Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.49,
    y: 326.66,
    width: 34.63,
    height: 59.96,
    transform: "translate(-200.19 611.15) rotate(-125.94)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.28,357.91a4.17,4.17,0,0,1-.93,5.83c-.15.11-.29.19-.44.28l11.67,16.1a3.4,3.4,0,0,1,.4-.34,4.18,4.18,0,0,1,5.83.94l.14.21,34.69-25.14-.16-.21a4.17,4.17,0,0,1,.93-5.83c.14-.1.29-.19.44-.28l-11.67-16.1-.4.34a4.2,4.2,0,0,1-5.84-.93c-.1-.15-.19-.29-.27-.44L30,357.51C30.06,357.63,30.17,357.77,30.28,357.91Zm31.07-5.29a6.85,6.85,0,1,1-9.57-1.52A6.86,6.86,0,0,1,61.35,352.62Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.22,228.33l28,12.9,23.07-31.08s-.33-7.84,0-9a40.26,40.26,0,0,1,3.59-5.87c.49-.66,1.47,0,1.63,1s-.49,1.8-.81,2.62-1,2.61-1,2.61l.81,2.45,8.65-6.86s2-2.61,2.62-1.47h0a2,2,0,0,1-.14,2.2l-3.94,5.31,2.61.16,6.36-5.38s1.14-.49,1.31,1h0a2.94,2.94,0,0,1-.92,2.47l-3.9,3.65-2.53,1.55,7.51-3.1s1,1,.65,1.47l-8.16,6.36,6-1s.82,1.14.33,1.8l-16.65,4.73s-23.23,43.65-23.56,44.3-3.75,2.12-6.36,1.31-36-15.35-36-15.35",
    style: {
      fill: "#55FF6A",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.14,239.78l12.21-22.94L161,212.11c.49-.66-.33-1.8-.33-1.8l-6,1,8.16-6.36c.33-.49-.65-1.47-.65-1.47l-7.51,3.1,2.53-1.55,3.9-3.65a2.94,2.94,0,0,0,.92-2.47c-.17-1.47-1.31-1-1.31-1l-6.36,5.38-2.61-.16,3.94-5.31a2,2,0,0,0,.14-2.2h0c-.66-1.14-2.62,1.47-2.62,1.47L144.51,204l-.81-2.45s.65-1.8,1-2.61,1-1.64.81-2.62-1.14-1.63-1.63-1a40.26,40.26,0,0,0-3.59,5.87c-.33,1.14,0,9,0,9l-17.12,23.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.51,204a8.79,8.79,0,0,1,2.14,2.65c.52,1.28-1.79,4.35-2.81,4.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.37,
    cy: 180.56,
    r: 44.99,
    transform: "translate(-76.6 176.18) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.37,
    cy: 180.56,
    r: 37.78,
    transform: "translate(-59.58 89.59) rotate(-24.75)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.13,214.94l-1.28-6q-6.72,1.17-10.87-2.15t-6.11-11.2l8.79-3.5a28,28,0,0,0,1.83,5.26,6.74,6.74,0,0,0,2.34,2.88,4,4,0,0,0,3.07.46,2.94,2.94,0,0,0,2.47-1.87,5.92,5.92,0,0,0,.12-3.14,9.8,9.8,0,0,0-2.7-5.2,23.43,23.43,0,0,0-5.13-3.61l-6.5-3.55a37.29,37.29,0,0,1-4.12-2.85,14.71,14.71,0,0,1-3.24-3.63,15.85,15.85,0,0,1-2.05-5.32q-1.29-6.08,1.45-10.21a14.67,14.67,0,0,1,8.46-5.82l-1.22-5.76,3.1-.66,1.23,5.76a12.19,12.19,0,0,1,6.06.37A9.8,9.8,0,0,1,182,158a16.28,16.28,0,0,1,2.65,4.23,33.91,33.91,0,0,1,1.68,4.68l-9,3.33a32.36,32.36,0,0,0-1.29-4.16,6.37,6.37,0,0,0-1.78-2.63,3.05,3.05,0,0,0-2.79-.42,3.35,3.35,0,0,0-2.45,2,5.36,5.36,0,0,0-.29,3.24,7.7,7.7,0,0,0,2.44,4.48,30.36,30.36,0,0,0,4,2.81l6.36,3.51a38.1,38.1,0,0,1,4.84,3.37,20,20,0,0,1,4,4.39,17.26,17.26,0,0,1,2.45,6.07,14.27,14.27,0,0,1-.07,6.54,11.8,11.8,0,0,1-3,5.42,13.43,13.43,0,0,1-5.73,3.38l1.29,6.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.31,424.51l11.87,8.4s7.16,1.47,8.08,2.21.91,3.85.91,3.85-7.33.92-14.12,1.1-10.28,0-15.6-.18-9.72.18-10.82-1.1,0-12.49,0-12.49S132,419.58,139.31,424.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.05,440.07c6.79-.18,14.12-1.1,14.12-1.1a14,14,0,0,0-.16-2c-7.59.62-21.69,1.6-25.52.67-4.36-1.05-12.52-1.48-15.34-1.61a5.75,5.75,0,0,0,.48,2.72c1.1,1.28,5.5.91,10.82,1.1S139.26,440.25,146.05,440.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.28,429.61l6.24,7.89,10.82,6.79c.73,2.2.37,2.75.18,3.49s-3.48.91-7.52.73-13.94,1.1-16.88.18-12.29-3.48-13.39-4-2.94-1.1-2.39-3.12,2.17-9.1,2.17-9.1A24.92,24.92,0,0,1,71.28,429.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,448.51c4,.18,7.34,0,7.52-.73a3.92,3.92,0,0,0,.21-1.93c-5,.21-18,.72-21.67.27-4.2-.5-16.37-5-18.42-5.75-.11.47-.22.87-.3,1.17-.55,2,1.29,2.57,2.39,3.12s10.46,3.12,13.39,4S77,448.33,81,448.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.36,302.16l5.2,62.94L52.42,423.23l-2.3,9.21s1.79,1.54,6.66,1.28,14.59-2.56,14.59-2.56a8.49,8.49,0,0,0,1-4.35c-.26-2.05-1.28-2.82-1.28-3.58S92.63,365.1,92.63,365.1l2-33.29,14.6,37.13,9.47,57.36s.52,2.82,1.28,2.56S133.6,424,133.6,424l4.86.52s.51-7.43-1.54-9a9.88,9.88,0,0,1-2.81-3.07l-2.05-54.54-20-56.08-1.8-6.91L64.2,297.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.36 302.16 63.77 305.59 112.09 301.85 110.01 297.34 63.36 302.16",
    style: {
      fill: "#55FF6A",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,223.65S55,233.6,55.36,238.17s6,40.65,6,40.65l2.13,13.87s-1.64,4.24-1.47,5.22-.17,3.59,1.3,4.25S77.24,302,90,301.67s17.63-.82,19.26-1.47,3.59-2.94,3.26-4.73a35.65,35.65,0,0,0-1.63-5.06s-.65-43.59-1.63-50.28-2.12-15.83-5.55-19.26S94.54,216,94.54,216L90,224.46s-15.67-6.36-21.38-7S58,223.65,58,223.65Z",
    style: {
      fill: "#55FF6A",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.55,255.44c-2.12.65-3.87,1.15-4.72,1.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,250.6s-6.08,2.13-11.5,3.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8,267.36A21,21,0,0,1,64.16,269",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.62,252.47s-7.72,7.72-14,12.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.25,233s-13.22-7-19.58-9-8.65-2.28-10.12-2-7.19,6.21-7.68,4.58,1.8-12.08,2.45-14.37,10.61-5.06,13.39-5.87,16.65,4.57,19.75,5.55,6,4.57,6,7S92.25,233,92.25,233Z",
    style: {
      fill: "#55FF6A",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.56,215.68s2.67-2.13,4.27-1.06,28.49,16.21,28.49,16.21l1.36-14.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5,172.83s2.32,7,2.32,8.74-.82,4.64-.27,5.73,3.82,6.14,3.28,7-2.6,3.82-2.6,3.82-.54,10.23-1.09,11.33-4.09,1-5.73,1H89s3,20.2,2.32,20.47-20.2-19.65-20.2-19.65l.68-14.6S65,186.48,66.07,182s11.74-8.05,17.47-9.55S96.5,172.83,96.5,172.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,188.2c.2,1-.1,2-.65,2.07s-1.16-.66-1.36-1.69.1-2,.66-2.07S94.79,187.16,95,188.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.32,184.57a4.56,4.56,0,0,1,4.91-1.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.27,195.76A9.17,9.17,0,0,0,95,199.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.26,191.26s3.55.54,3.55-.41-.41-4.51-.41-4.51,4.77-3.82,4.64-5.59-2.32-3.28-2.19-3.82,6.55-2.46,11.74-2.46,6.28,1.09,7.92-1.37,2.86-5.73-.28-9.14-4.64-1.91-6.27-2.32-6.42-5.19-9.69-4.09a5.38,5.38,0,0,0-3.69,4.09s-6.14-4.09-8.73-1.91A7.79,7.79,0,0,0,68,164.37a7,7,0,0,0-5.73,3.82c-1.78,3.69-1.64,5.73-1.64,5.73S57.2,176,57.34,179a8.75,8.75,0,0,0,1.09,4.37s-2.87,1.23,0,5.59,4,4.92,4,4.92-3.27.41,0,3.14,9.28,3.82,10.65,4.5,1.64-3.82,1.64-6.55A10.66,10.66,0,0,0,74.26,191.26Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.44,192.62S72.89,188,71,189.48s-.68,8.05,1.37,10.1,5.05-1.5,5.05-1.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89 210.36 83.11 210.26 89.97 217.28 89 210.36",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.62,227.56l28,12.9,23.06-31.08s-.32-7.83,0-9,3.11-5.22,3.6-5.87,1.46,0,1.63,1-.49,1.79-.82,2.61-1,2.61-1,2.61l.82,2.45,8.65-6.86s2-2.61,2.61-1.47h0a2,2,0,0,1-.13,2.2l-4,5.31,2.61.17,6.37-5.39s1.14-.49,1.3,1h0a2.93,2.93,0,0,1-.91,2.48l-3.91,3.64L140,205.79l7.51-3.1s1,1,.65,1.47L140,210.52l6-1s.81,1.15.32,1.8l-16.65,4.73s-23.23,43.65-23.55,44.3-3.76,2.12-6.37,1.31-36-15.34-36-15.34",
    style: {
      fill: "#55FF6A",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.55,239l12.2-22.94,16.65-4.73c.49-.65-.32-1.8-.32-1.8l-6,1,8.16-6.36c.33-.49-.65-1.47-.65-1.47l-7.51,3.1,2.52-1.55,3.91-3.64a2.93,2.93,0,0,0,.91-2.48c-.16-1.47-1.3-1-1.3-1l-6.37,5.39-2.61-.17,4-5.31a2,2,0,0,0,.13-2.2h0c-.65-1.14-2.61,1.47-2.61,1.47l-8.65,6.86-.82-2.45s.65-1.8,1-2.61,1-1.63.82-2.61-1.15-1.64-1.64-1-3.26,4.73-3.59,5.87,0,9,0,9l-17.11,23.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353,107.49V410.55A15.06,15.06,0,0,1,338,425.61H207A15.06,15.06,0,0,1,192,410.55V107.49A15.05,15.05,0,0,1,207,92.43h56.2l0,.18c1.4,5,4.63,8.32,8.2,8.32h2.06c3.57,0,6.8-3.28,8.2-8.32l0-.18H338A15.06,15.06,0,0,1,353,107.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,116.07v-8.58A15.06,15.06,0,0,0,338,92.43H281.78l0,.18c-1.4,5-4.63,8.32-8.2,8.32h-2.06c-3.57,0-6.8-3.28-8.2-8.32l0-.18H207A15.05,15.05,0,0,0,192,107.49v8.58Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,402.45v8.1A15.06,15.06,0,0,0,207,425.61H338A15.06,15.06,0,0,0,353,410.55v-8.1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.28,179.88V149.61h-2.74V110.86A23.9,23.9,0,0,0,336.65,87H208.35a23.9,23.9,0,0,0-23.89,23.89V418.78a23.9,23.9,0,0,0,23.89,23.89h128.3a23.9,23.9,0,0,0,23.89-23.89V205.67h2.74V187.79h-2.74v-7.91ZM353,401.72a23.89,23.89,0,0,1-23.88,23.89H215.85A23.89,23.89,0,0,1,192,401.72V116.31a23.89,23.89,0,0,1,23.88-23.88h47.37l0,.18c1.4,5,4.63,8.32,8.2,8.32h2.06c3.57,0,6.8-3.28,8.2-8.32l0-.18h47.37A23.89,23.89,0,0,1,353,116.31Z",
    style: {
      fill: "#55FF6A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.74,90.26H210.26a23,23,0,0,0-23,23v303a23,23,0,0,0,23,23H334.74a23,23,0,0,0,23-23v-303A23,23,0,0,0,334.74,90.26ZM353,402.57a23,23,0,0,1-23,23H215a23,23,0,0,1-23-23V115.47a23,23,0,0,1,23-23h48.22l0,.18c1.4,5,4.63,8.32,8.2,8.32h2.06c3.57,0,6.8-3.28,8.2-8.32l0-.18H330a23,23,0,0,1,23,23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.25,93.58A2.24,2.24,0,1,0,272,95.82,2.24,2.24,0,0,0,274.25,93.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.28,102.17c0,2.27-2.55,3.08-2.56,4.82v.11h2.48v.77h-3.3v-.65c0-2.43,2.54-2.9,2.54-5,0-.77-.25-1.18-.88-1.18s-.88.44-.88,1.11v.66h-.78v-.61c0-1.15.52-1.91,1.68-1.91S206.28,101,206.28,102.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4,102.16v.19a1.5,1.5,0,0,1-.91,1.55,1.5,1.5,0,0,1,.91,1.56V106c0,1.15-.54,1.9-1.7,1.9S207,107.19,207,106v-.52h.78v.57c0,.68.28,1.09.88,1.09s.88-.4.88-1.16v-.58c0-.74-.31-1.1-.94-1.12h-.45v-.75h.49c.56,0,.9-.38.9-1v-.34c0-.77-.27-1.17-.88-1.17s-.88.42-.88,1.1v.38H207v-.34c0-1.15.53-1.89,1.68-1.89S210.4,101,210.4,102.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,102.73v1h-.81v-1Zm0,4.09v1.05h-.81v-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.73,103.41a1.2,1.2,0,0,1,1.11-.63c1,0,1.4.71,1.4,1.79V106c0,1.15-.55,1.9-1.7,1.9s-1.69-.75-1.69-1.9v-.51h.79v.56c0,.68.28,1.09.88,1.09s.88-.41.88-1.09v-1.46c0-.68-.28-1.08-.88-1.08a.81.81,0,0,0-.85.8v.17h-.78l.2-4.18h3v.75h-2.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.43,102.15v.14h-.79v-.2c0-.67-.28-1.07-.89-1.07s-.92.41-.92,1.21v1.69a1.24,1.24,0,0,1,1.22-.81c1,0,1.4.7,1.4,1.79V106c0,1.15-.57,1.9-1.72,1.9S217,107.19,217,106V102.2c0-1.19.53-1.93,1.73-1.93S220.43,101,220.43,102.15Zm-2.6,2.81v1.13c0,.68.28,1.09.9,1.09s.89-.41.89-1.09V105c0-.67-.29-1.08-.89-1.08S217.83,104.29,217.83,105Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.46,
    y: 102.48,
    width: 2.12,
    height: 5.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.3,
    y: 101.41,
    width: 2.13,
    height: 6.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.13,
    y: 100.66,
    width: 2.13,
    height: 7.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.96,
    y: 99.34,
    width: 2.12,
    height: 8.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.39,107.65H324.64v-7.8h12.75Zm-12-.71h11.33v-6.38H325.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.41,
    y: 101.33,
    width: 6.73,
    height: 4.83,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.94,
    y: 102.83,
    width: 1.6,
    height: 1.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,106a.42.42,0,0,1-.24-.07c-2.6-1.54-4.31-.11-4.38,0a.48.48,0,0,1-.67,0,.47.47,0,0,1,0-.67c.09-.08,2.29-2,5.5-.06a.48.48,0,0,1,.16.66A.48.48,0,0,1,320,106Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.92,104.35a.42.42,0,0,1-.24-.07c-3.75-2.23-6.28-.07-6.3,0a.47.47,0,0,1-.67,0,.47.47,0,0,1,0-.67s3.07-2.64,7.42-.06a.48.48,0,0,1,.16.66A.48.48,0,0,1,320.92,104.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.79,102.5a.55.55,0,0,1-.24-.07c-4.75-2.83-7.91-.17-8-.05a.49.49,0,0,1-.68,0,.48.48,0,0,1,.05-.67s3.79-3.24,9.16,0a.47.47,0,0,1,.16.65A.49.49,0,0,1,321.79,102.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.53,106.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,318.53,106.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--credit-card--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.57,
    y: 250.76,
    width: 136.41,
    height: 84.63,
    rx: 7.17,
    style: {
      fill: "#55FF6A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.03,
    y: 317.47,
    width: 14.44,
    height: 5.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.2,
    y: 317.47,
    width: 14.44,
    height: 5.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.36,
    y: 317.47,
    width: 14.44,
    height: 5.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.53,
    y: 317.47,
    width: 14.44,
    height: 5.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.7,
    y: 317.47,
    width: 14.44,
    height: 5.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.87,
    y: 317.47,
    width: 14.44,
    height: 5.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.03,
    y: 280.13,
    width: 31.36,
    height: 23.4,
    rx: 3.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.03,
    y: 260.72,
    width: 68.7,
    height: 3.48,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Symbol--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 269.37,
    cy: 184.56,
    r: 34.13,
    transform: "translate(28.61 405.14) rotate(-76.91)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.76,216.39v-5.55q-6.15-.24-9.2-4t-3.28-11l8.42-1.43a24.7,24.7,0,0,0,.63,5,6.15,6.15,0,0,0,1.52,3,3.61,3.61,0,0,0,2.63,1,2.68,2.68,0,0,0,2.54-1.2,5.36,5.36,0,0,0,.69-2.74,8.84,8.84,0,0,0-1.41-5.11,21.39,21.39,0,0,0-3.85-4.15l-5.08-4.36a33.72,33.72,0,0,1-3.1-3.29,13.06,13.06,0,0,1-2.18-3.82,14.4,14.4,0,0,1-.81-5.08q0-5.61,3.19-8.75a13.29,13.29,0,0,1,8.58-3.55V156h2.86v5.32a11,11,0,0,1,5.29,1.46,8.89,8.89,0,0,1,3.14,3.23,15.11,15.11,0,0,1,1.55,4.24,29.79,29.79,0,0,1,.6,4.45L273.94,176a27,27,0,0,0-.35-3.91,5.72,5.72,0,0,0-1.08-2.66,2.78,2.78,0,0,0-2.39-.9,3,3,0,0,0-2.54,1.32,4.88,4.88,0,0,0-.86,2.81A6.94,6.94,0,0,0,268,177a28,28,0,0,0,3,3.22l5,4.3a33.6,33.6,0,0,1,3.65,3.89,18.33,18.33,0,0,1,2.69,4.62,15.79,15.79,0,0,1,1,5.83,12.89,12.89,0,0,1-1.28,5.76,10.6,10.6,0,0,1-3.7,4.21,12.09,12.09,0,0,1-5.71,1.92v5.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.15,
    cy: 166.16,
    r: 9.67,
    style: {
      fill: "#55FF6A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.12,170.37h0a1.33,1.33,0,0,1-1-.52l-4.77-6.17a1.33,1.33,0,1,1,2.11-1.63l3.77,4.89,9.89-11.4a1.33,1.33,0,0,1,2,1.74l-10.95,12.63A1.33,1.33,0,0,1,296.12,170.37Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/approvedIcon.962b657639e85691350d9d5a1aceffdd.svg";
export { ForwardRef as ReactComponent };